import React from 'react';
import clsx from 'clsx';
import { CardHeaderProps } from './tools/CardHeader.model';

import useStyles from './CardHeader.style';

const CardHeader: React.FC<CardHeaderProps> = ({ children, layout = 'normal', className }) => {
  const c = useStyles({ layout });

  return (
    <header className={clsx(c.root, className)}>
      {children}
    </header>
  );
};

export { CardHeader };
